import React from "react";
import { FormProvider } from "react-hook-form";
import { Button, Dialog, Form } from "@sscs/ui";
import { Member } from "Types";
import OrganizationRoleAutocomplete from "../OrganizationalRoleAutocomplete/OrganizationRoleAutocomplete";
import useEditMember from "./useEditMember";

type EditMemberProps = {
  initialValues: Member;
  isOpen: boolean;
  onClose: () => void;
};

const EditMemberContent = ({
  initialValues,
  onClose,
}: Omit<EditMemberProps, "isOpen">): React.JSX.Element | null => {
  const { form, groups, onSubmit } = useEditMember(initialValues, onClose);

  if (!groups) return null;

  const groupIds: string[] = groups
    .filter((group) => group.group_id !== undefined)
    .map((group) => group.group_id as string);

  const errors = form.formState.errors;

  return (
    <>
      <Dialog.Header>
        <Dialog.Header.Title>Edit member</Dialog.Header.Title>
      </Dialog.Header>
      <FormProvider {...form}>
        <Form.Form onSubmit={onSubmit}>
          <Dialog.Body>
            <Dialog.Section>
              <Dialog.Section.Content>
                <Form.TextField
                  id="edit-member-email"
                  label="Email"
                  name="email"
                  type="email"
                  isRequired
                  errors={errors}
                  isDisabled
                />
                <Form.Autocomplete
                  id="edit-member-groups"
                  name="orgGroups"
                  label="Groups"
                  errors={errors}
                  options={groupIds}
                  multiSelect={true}
                  getOptionLabel={(option) =>
                    groups.find((group) => group.group_id === option)?.name ??
                    ""
                  }
                />
                <OrganizationRoleAutocomplete />
              </Dialog.Section.Content>
            </Dialog.Section>
          </Dialog.Body>
          <Dialog.Footer>
            <Dialog.Footer.Actions>
              <Button color="secondary" onClick={onClose}>
                Cancel
              </Button>
              <Button type="submit" color="primary">
                Edit member
              </Button>
            </Dialog.Footer.Actions>
          </Dialog.Footer>
        </Form.Form>
      </FormProvider>
    </>
  );
};

const EditMember = ({
  isOpen,
  ...props
}: EditMemberProps): React.JSX.Element => (
  <Dialog.Frame isOpen={isOpen} onClose={props.onClose}>
    <EditMemberContent {...props} />
  </Dialog.Frame>
);

export default EditMember;
